import { ProjectsRemediationRateDetails } from '@models';

export interface ProjectsRemediationRateDetailsResult {
  projectsRemediationRateDetails: ProjectsRemediationRateDetails;
}
